<style scoped>
</style>

<template>
	<v-dialog 
		v-model="visible" 
		max-width="300" 
		persistent
	>
		<v-card>
			<v-card-title>{{ title }}</v-card-title>
			<v-card-text>
				<v-alert type="error" v-if="errormsg != ''">{{
					errormsg
				}}</v-alert>

				<v-text-field
					v-model="worklist.name"
					outlined
					hide-details
				/>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters justify="center" v-if="!saving">
					<v-btn 
						outlined 
						@click="close()" 
						color="grey" 
						class="mr-1 mb-2 text-capitalize"
					>
						Cancel
					</v-btn>
					<v-btn 
						@click="save()" 
						color="light-blue"
						class="white--text ml-1 mb-2 text-capitalize"
					>
						Save
					</v-btn>
				</v-row>
				<v-row no-gutters justify="center" v-if="saving">
					<v-progress-circular
						indeterminate
						color="light-blue"
					/>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Worklist from "@/models/worklist.js";

export default {
	data() {
		return {
			errormsg: "",
			title: "Save worklist",
			worklist: new Worklist(),
			visible: false,
			saving: false,
		}
	},
	methods: {
		open(worklist, save_as = false) {
			// create as new worklist
			this.worklist.id = 0;
			this.worklist.class = worklist.class;
			this.worklist.name = worklist.name;
			this.worklist.settings = worklist.settings;
			this.worklist.is_dynamic = worklist.is_dynamic;
			this.worklist.details = worklist.details;
			this.worklist.is_owned = true;

			// console.log(this.worklist);

			if (save_as) {
				this.title = "Save as worklist...";
			} else {
				this.title = "Create copy...";
			}

			this.errormsg = "";
			this.visible = true;
		},
		save() {
			// Should validate our entry

			// and save
			this.saving = true;
			this.errormsg = "";
			let self = this;

			this.worklist.create()
				.then(function(data) {
					// close dialog
					self.visible = false

					// let the world know
					self.$emit('saved', data);
				})
				.catch(function(reason) {
					// record our error message
					self.errormsg = reason;
				})
				.finally(function() {
					// no longer saving
					self.saving = false;
				});
		}, 
		close() {
			this.visible = false;
		}
	}
}
</script>